<template>
    <BasePanel>
        <template #title>
            Hoe werkt de wachtlijst?
        </template>

        <template #default>
            <!-- eslint-disable vue/no-v-html -->
            <p
                v-if="waitingListInfo"
                v-html="waitingListInfo"
            />
            <!-- eslint-enable -->

            <BaseButton
                class="button button--secondary button--stretch"
                @click="$emit('close')"
            >
                Begrepen
            </BaseButton>
        </template>
    </BasePanel>
</template>

<script setup lang="ts">
import { useEventsStore } from '~/stores/events';

defineEmits(['close']);

const eventsStore = useEventsStore();

const waitingListInfo = computed(() =>
    eventsStore.waitingListInfo
        ? replaceEventTitlePlaceholder(eventsStore.waitingListInfo, eventsStore.activeEvent?.title)
        : null
);
</script>
